import { Gender } from '@features/onboarding/enums/gender.enum';
import {
  DentalAndVisionPlansSchema,
  DependentItemFormType,
  SummaryPlansSchema,
  MedicalPlansSchema,
} from '@features/onboarding/schema/onboarding';
import { Tier } from 'src/services/interfaces/tier';

export const DEFAULT_DEPENDENTS_FORM: DependentItemFormType = {
  applicant: 'primary',
  firstName: '',
  midName: undefined,
  lastName: '',
  dateOfBirth: { month: '', day: '', year: '' },
  gender: undefined as 'male' | 'female' | undefined,
  height: { ft: NaN, in: NaN },
  weight: NaN,
  nicotine: false,
  ssn: '',
};

export const GENDER_OPTIONS = [
  { label: 'Male', value: Gender.MALE },
  { label: 'Female', value: Gender.FEMALE },
];

export const DEFAULT_MEDICAL_PLANS_FORM: Partial<MedicalPlansSchema> = {
  medicalTags: [],
  medicalPlan: '',
  medicalPlansToCompare: [],
};

export const DEFAULT_DENTAL_AND_VISION_PLANS_FORM: Partial<DentalAndVisionPlansSchema> =
  {
    planTags: {},
    dentalAndVisionTags: [], // Keep for backward compatibility
    dentalPlan: '',
    dentalPlansToCompare: [],
  };

export const DEFAULT_MARKETPLACE_PLANS_FORM: Partial<SummaryPlansSchema> = {
  marketplaceTags: [],

  identityProtectionPlan: '',
  identityProtectionPlansToCompare: [],

  legalPlan: '',
  legalPlansToCompare: [],

  telehealthPlan: '',
  telehealthPlansToCompare: [],
  
  criticalillnessPlan: '',
  criticalillnessPlanPrice: 0,
  criticalillnessPlanTier: '',
  criticalillnessPlanCoverageAmount: 10000,
  criticalillnessPlanDependentBenefit: 5000,
  criticalillnessPlansToCompare: [],
};

export const MAX_DEPENDENTS = 11;

// id страниц для хуков Дани
export const AI_HOOKS_IDS = {
  WELCOME: "welcome",
  DEPENDENTS: "dependents",
  HEALTH_PLANS: "health_plans",
  DENTAL_PLANS: "dental_plans",
  VISION_PLANS: "vision_plans",
  ACCIDENT_PLANS: "accident_plans",
  CRITICAL_ILLNESS_PLANS: "critical_illness_plans",
  HOSPITAL_INDEMNITY_PLANS: "hospital_indemnity_plans",
  PHQ: "phq",
  MEDICATIONS: "medications",
  MEDICAL_CONDITIONS: "medical_conditions",
  EFFECTIVE_DATE: "effective_date",
  LEGAL: "legal",
  APPROVED: "approved",
  NEED_REVIEW: "need_review",
  REJECTED: "rejected",
  PLAN_SUMMARY: "plan_summary",
  PAYMENT: "payment",
  ADDRESS_SSN: "address_ssn",
  MAXED_OUT: "maxed_out",
};

export const DEFAULT_TIER = Tier.Tier1;
